// Julkiset kirjastot
import React, { useState, useEffect, useContext } from "react";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// Sovelluksen komponentit
import { LanguageContext } from "./LanguageContext";

// Funktio
export const ConfirmCancelDialog = ({ open, onCancel, onOk }) => {

    // Toistuvat muuttujat
    const { dictionary } = useContext(LanguageContext);

    return (
        <React.Fragment>
            <Dialog
                open={open}
            >
                <DialogTitle>{dictionary.CancelConfirmation.Title}</DialogTitle>
                <DialogContent>
                    <DialogContentText color="primary">
                        {dictionary.CancelConfirmation.Text}
                    </DialogContentText>
                </DialogContent>
                {/* TODO:THEME */}
                <DialogActions
                    style={{ backgroundColor: "#3C495A" }}
                >
                    <ButtonGroup variant="comboButton">
                        <Button variant="Secondary" onClick={onCancel}>
                            {dictionary.Cancel}
                        </Button>
                        <Button variant="Primary" onClick={onOk}>
                            {dictionary.Ok}
                        </Button>
                    </ButtonGroup>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
